<template>
    <div>
        <Header title="员工信息" memo="管理机构员工账号信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    添加
                </a-button>

                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>

                <a-button-group>
                    <a-button icon="lock" @click="execLock" :disabled="selRows.length === 0">
                        锁定
                    </a-button>
                    <a-button icon="unlock" @click="execUnlock" :disabled="selRows.length === 0">
                        解锁
                    </a-button>
                </a-button-group>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="员工名称" @pressEnter="execQuery">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column data-index="name" ellipsis>
                <span slot="title">员工信息</span>
                <template slot-scope="text, record">
                    <span>
                        <a-tag color="#f50" v-if="record.lock.flg">
                            已锁定
                        </a-tag>
                        <a-tag color="#2db7f5" style="width: 100px; text-align: center;">
                            {{ record.id }}
                        </a-tag>
                        {{ record.name }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column data-index="name" ellipsis width="100px">
                <span slot="title">角色</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.role === 'UnitAdmin' ? '管理员' : '员工' }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column data-index="name" ellipsis width="100px">
                <span slot="title">创建数量</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.tcount }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="eye" @click="showView(record)">
                        详情
                    </a-button>
                    <template v-if="!record.adm">
                        <a-popconfirm :title="'是否删除员工[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                            <a-button type="link" icon="delete">
                                删除
                            </a-button>
                        </a-popconfirm>
                        <a-popconfirm v-if="record.lock.flg" :title="'是否解除员工[' + record.name + ']的锁定状态？'" ok-text="解除锁定" cancel-text="取消" @confirm="doUnlock(record.id)">
                            <a-button type="link" icon="unlock">
                                解锁
                            </a-button>
                        </a-popconfirm>
                        <a-popconfirm v-else :title="'是否锁定员工[' + record.name + ']的登录状态？'" ok-text="锁定登录" ok-type="danger" cancel-text="取消" @confirm="doLock(record.id)">
                            <a-button type="link" icon="lock">
                                锁定
                            </a-button>
                        </a-popconfirm>
                        <a-dropdown>
                            <a-button type="link">
                                更多
                                <a-icon type="down" />
                            </a-button>
                            <a-menu slot="overlay">
                                <a-menu-item key="0">
                                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                                        编辑
                                    </a-button>
                                </a-menu-item>
                                <a-menu-item key="1">
                                    <a-button type="link" v-if="!record.wxmp.bind && record.wxmp.code" icon="cloud-download" @click="execDownQr(record)">
                                        下载绑定码
                                    </a-button>
                                </a-menu-item>
                                <a-menu-item key="2">
                                    <a-button type="link" icon="radius-setting" @click="showResetForm(record)">
                                        重置绑定
                                    </a-button>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑员工" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>

        <ViewComp title="员工详情" :item="now" :show.sync="view" v-if="view"></ViewComp>

        <ResetComp title="重置绑定" :item="now" :show.sync="reset" v-if="reset" @doLoad="doLoad"></ResetComp>
    </div>
</template>

<script>
import FormComp from './FormComp'
import ViewComp from './ViewComp'
import ResetComp from './ResetComp'

export default {
    name: 'UnitEmp',
    components: {
        FormComp,
        ViewComp,
        ResetComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            reset: false,
            form: false,
            now: {}
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['用户管理', '员工信息'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/ums/unit/emp/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/ums/unit/emp/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doLock(ids) {
            this.$http
                .post('/ums/user/mgr/lock', {
                    uids: typeof ids === 'string' ? ids : ids.join(),
                    memo: '后台操作，锁定登录'
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('锁定成功')
                        this.doLoad()
                    }
                })
        },
        doUnlock(ids) {
            this.$http
                .post('/ums/user/mgr/unlock', {
                    uids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('解除锁定成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                name: ''
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}

            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },
        showResetForm(item) {
            this.now = item
            this.reset = true
        },
        showView(item) {
            this.now = item
            this.view = true
        },
        execDownQr(item) {
            if (item.wxmp.qrst) {
                window.open('https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + item.wxmp.qrst)
            }
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的用户')
                return
            }
            this.$confirm({
                title: '是否删除以下用户？删除后无法恢复。',
                content: '用户：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        },
        execLock() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要锁定登录的用户')
                return
            }
            this.$confirm({
                title: '是否锁定以下用户登录？',
                content: '用户：[' + names.join() + ']',
                okText: '锁定登录',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doLock(ids)
                }
            })
        },
        execUnlock() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要解除锁定的用户')
                return
            }
            this.$confirm({
                title: '是否解除以下用户锁定状态？',
                content: '用户：[' + names.join() + ']',
                okText: '解除锁定',
                okType: 'primary',
                cancelText: '取消',
                onOk: () => {
                    this.doUnlock(ids)
                }
            })
        }
    }
}
</script>
